import { BotIcon, type LucideProps } from "lucide-react"
import type { ComponentType } from "react"
import {
  AlephAlphaIcon,
  AmazonBedrockIcon,
  AmazonSagemakerIcon,
  AzureIcon,
  ClaudeIcon,
  CloudflareIcon,
  CloudflareWorkersIcon,
  CohereIcon,
  CopilotIcon,
  CrewaiIcon,
  DeepseekIcon,
  DspyIcon,
  GeminiIcon,
  GitlabIcon,
  GrokIcon,
  GroqIcon,
  HaystackIcon,
  HuggingfaceIcon,
  KilocodeIcon,
  KimiIcon,
  LangchainIcon,
  LitellmIcon,
  LlamaindexIcon,
  MetaIcon,
  MistralIcon,
  NvidiaIcon,
  OllamaIcon,
  OpenaiIcon,
  OpencodeIcon,
  OpenrouterIcon,
  PerplexityIcon,
  QwenIcon,
  ReplicateIcon,
  ReplitIcon,
  TogetherIcon,
  V0Icon,
  VercelIcon,
  WatsonxIcon,
} from "./icons/index.tsx"

type ProviderIconComponent = ComponentType<LucideProps>

// Providers from https://models.dev/
// Icons from https://svgl.app/
export const PROVIDER_ICON_MAP: Record<string, ProviderIconComponent> = {
  /** Generic / framework integrations without a dedicated brand mark */
  generic: BotIcon,
  "aleph-alpha": AlephAlphaIcon,
  alibaba: QwenIcon,
  "alibaba-cn": QwenIcon,
  "amazon-bedrock": AmazonBedrockIcon,
  "amazon-sagemaker": AmazonSagemakerIcon,
  anthropic: ClaudeIcon, // Alternative: AnthropicIcon
  azure: AzureIcon, // Alternative: OpenaiIcon
  "azure-cognitive-services": AzureIcon,
  claude: ClaudeIcon,
  "cloudflare-ai-gateway": CloudflareIcon,
  "cloudflare-workers-ai": CloudflareWorkersIcon,
  cohere: CohereIcon,
  crewai: CrewaiIcon,
  deepseek: DeepseekIcon,
  dspy: DspyIcon,
  "github-copilot": CopilotIcon,
  gitlab: GitlabIcon,
  google: GeminiIcon,
  "google-vertex": GeminiIcon,
  "google-vertex-anthropic": ClaudeIcon, // Alternative: AnthropicIcon
  groq: GroqIcon,
  haystack: HaystackIcon,
  huggingface: HuggingfaceIcon,
  kilo: KilocodeIcon,
  "kimi-for-coding": KimiIcon,
  langchain: LangchainIcon,
  litellm: LitellmIcon,
  llama: OllamaIcon,
  llamaindex: LlamaindexIcon,
  MetaIcon,
  mistral: MistralIcon,
  moonshotai: KimiIcon,
  "moonshotai-cn": KimiIcon,
  nvidia: NvidiaIcon,
  "ollama-cloud": OllamaIcon,
  openai: OpenaiIcon,
  opencode: OpencodeIcon,
  "opencode-go": OpencodeIcon,
  openrouter: OpenrouterIcon,
  perplexity: PerplexityIcon,
  replicate: ReplicateIcon,
  replit: ReplitIcon,
  togetherai: TogetherIcon,
  v0: V0Icon,
  vercel: VercelIcon,
  watsonx: WatsonxIcon,
  xai: GrokIcon, // Alternative: XaiIcon
}
